import { Link, useLocation } from "@tanstack/react-router";

export function SignInLink(props: Omit<React.ComponentProps<typeof Link>, "to" | "search">) {
	const location = useLocation();

	return (
		<Link
			{...props}
			from={location.pathname}
			to="/sign-in"
			search={{ from: location.pathname }}
		/>
	);
}
